<template>
  <div id="rtc">
    <div class="firstPart">
      <div class="topPart">
        <h2 class="title">视频RTC</h2>
      </div>
      <el-row class="elRow">
        <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" align="left">
          <div class="leftImgBox">
            <img
              src="../../../assets/img/product/videortc.png"
              alt=""
              class="leftImg"
            />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="rightInfo wow fadeInUp">
            <div
              class="taskType"
              v-for="(item, index) in rtcItemArr"
              :key="index"
            >
              <img
                src="../../../assets/img/product/dhs.png"
                alt=""
                class="typeImg"
              />
              <div class="typeName">{{ item.name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="lastPart">
      <div class="title">
        视频RTC平台展示
      </div>
      <div class="imgBox">
        <el-row :gutter="30" class="elRow" type="flex" align="center" justify='center'>
          <viewer :images="srcListArr" class="viewerImg" style="height: 100%">
            <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" align="center">
              <div
                class="innerBox"
                v-for="(citem, idx) in srcListArr[0].children"
                :key="idx"
              >
                <img :src="citem.src" title="查看大图" />
                <div class="tagName">{{ citem.name }}</div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" align="center">
              <div class="innerBox colImgbox">
                <img :src="srcListArr[1].src" title="查看大图" />
                <div class="tagName">{{ srcListArr[1].name }}</div>
              </div>
            </el-col>
          </viewer>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      srcListArr: [
        {
          children: [
            {
              src: require("../../../assets/img/product/rtc1.png"),
              name: "视频显示",
            },
            {
              src: require("../../../assets/img/product/rtc2.png"),
              name: "远程监控",
            },
          ],
        },
        {
          src: require("../../../assets/img/product/rtc3.jpg"),
          name: "视频监控",
          children: [],
        },
      ],
      rtcItemArr: [
        { name: "无需安装客户端/插件" },
        { name: "支持不同厂家视频统一播放" },
        { name: "支持浏览器/IOS/安卓/微信端播放" },
        { name: "支持按需压缩分辨率" },
        { name: "支持按需调取，节约带宽/流量" },
        { name: "不限制同时观看用户数" },
        { name: "不限制并发观看视频数" },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
#rtc {
  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
    }
  }
  .firstPart {
    padding: 5% 14%;
    .elRow {
      display: flex;
      flex-wrap: wrap;
      margin-top: 5rem;
    }
    .leftImgBox {
      width: 75%;
      padding: 2rem;
      height: 100%;
    }
    .leftImg {
      width: 88%;
      height: 100%;
    }
    .rightInfo {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .taskSource {
        font-size: 1.6rem;
        font-weight: bold;
        color: #333333;
        line-height: 3rem;
        width: 69%;
      }
      .taskType {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 2rem;
        .typeImg {
          width: 2rem;
          height: 2rem;
          margin-right: 1rem;
        }
        .typeName {
          font-size: 1.6rem;
          color: #696969;
          line-height: 2.6rem;
        }
      }
      .typeDesc {
        font-size: 1.4px;
        color: #696969;
        line-height: 2.6rem;
      }
    }
  }
  .lastPart {
    padding: 5% 14%;
    .title {
      font-size: 2.8rem;
      color: #333333;
      line-height:3rem;
      width: 100%;
      text-align: center;
      margin-bottom: 3rem;
    }
    .imgBox {
      .elRow {
        display: flex;
        flex-wrap: wrap;
      }
      .innerBox {
        position: relative;
        margin-top: 3rem;
        width: 100%;
        height: 33rem;
        overflow: hidden;
        img {
          width: 100%;
        //   height: 100%;
          cursor: pointer;
        }
        .tagName {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: rgba(0, 0, 0, 0.8);
          color: #ffffff;
          border-radius: 2rem;
          padding: 1rem 2rem;
        }
        .bigEye {
          position: absolute;
          bottom: 0rem;
          right: 0rem;
          cursor: pointer;
          background: #18b09b;
          width: 3rem;
          height: 3rem;
        }
      }

      .colImgbox {
        height: 69rem;
        img {
          width: 100%;
        //   height: 100%;
          object-fit: contain;
          cursor: pointer;
        }
      }
    }
  }
  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import '../../../assets/responsive/rtc.scss'
</style>
